import VideoCard from "@blocks/Card/VideoCard";
import VideoDialog from "@components/Layouts/Player/VideoDialog";
import { BC_PLAYER_ID_SINGLE_PLAYER } from "@helper/getEnvVariables";
import useSwrApi from "@hooks/useSwrApi";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { type LatestVideoResponse } from "@transformer/useBrightcoveResponse";
import { useState } from "react";

export default function LatestVideo() {
  const { isScreenLG } = useWindowSize();
  const videoCount = isScreenLG ? 6 : 1;

  const { data: videos } = useSwrApi<LatestVideoResponse[]>("latest-videos");

  const [videoDialog, setVideoDialog] = useState({
    visible: false,
    source: "",
  });

  const openVideoDialog = (source?: string) => {
    setVideoDialog({
      visible: true,
      source: source || "",
    });
  };

  const closeVideoDialog = (source?: string) => {
    setVideoDialog({
      visible: false,
      source: source || "",
    });
  };

  return (
    <>
      {videos ? (
        <>
          <VideoCard<LatestVideoResponse>
            renderedVideos={videos.slice(0, videoCount)}
            handleOnClickCallback={openVideoDialog}
          />
          <VideoDialog
            videoDialog={videoDialog}
            handleOnClickCloseDialog={closeVideoDialog}
            playerId={BC_PLAYER_ID_SINGLE_PLAYER}
          />
        </>
      ) : null}
    </>
  );
}
